import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TogglePane from "./graphComponents/TogglePane";
import Header from "./graphComponents/Header";
import PanelInstance from "./PanelInstance";
import PanelMethods from "./graphComponents/PanelMethods";
import Summary from "./graphComponents/Summary";
import { DATA_SET_CHANGE } from "../../../../redux/actions/graphs";

const TogglePanel = ({ serverdata, slug, size }) => {
  const dispatch = useDispatch();

  const data = serverdata;

  const graphState = useSelector(
    (state) => state.graphState[data.figureNumber]
  );
  const toggleValues = Array.from(
    new Set(data.togglePanel.flatMap((x) => x.toggle))
  );

  let iTog = toggleValues[0];

  if (data.figureJson) {
    try {
      const figJson = JSON.parse(data.figureJson);
      if (figJson.defaultToggle) {
        iTog = figJson.defaultToggle;
      }
    } catch {
      console.warn("tried to parse non-json json");
    }
  }

  const cToggle =
    graphState && graphState.toggle ? graphState.toggle : iTog;

  const [currentToggle, setToggle] = useState(cToggle);

  const initialPanel =
    data && data.togglePanel
      ? data.togglePanel.filter((x) => x.toggle === currentToggle)[0]
      : null;

  const [initPanel, setInitPanel] = useState(initialPanel);

  const toggleDataSet = (newToggle) => {
    setToggle(newToggle);

    setInitPanel(data.togglePanel.filter((x) => x.toggle === newToggle)[0]);

    dispatch({
      type: DATA_SET_CHANGE,
      payload: {
        figureNumber: data.figureNumber,
        toggle: newToggle,
      },
    });
  };

  const panelLayout = (panels) => {
    let i = 0;
    const divs = [];
    while (i < panels.length) {
      if (i % 2 === 0) {
        if (i + 1 < panels.length) {
          divs.push(
            <div className="subpanels" key={i}>
              <PanelInstance
                panel={{
                  ...data,
                  panel: { ...panels[i], panelCount: panels.length },
                }}
                size={size}
                slug={slug}
                toggle={currentToggle}
              />
              <PanelInstance
                panel={{
                  ...data,
                  panel: { ...panels[i + 1], panelCount: panels.length },
                }}
                size={size}
                slug={slug}
                toggle={currentToggle}
              />
            </div>
          );
        } else {
          divs.push(
            <div className="subpanels" key={i}>
              <PanelInstance
                panel={{
                  ...data,
                  panel: { ...panels[i], panelCount: panels.length },
                }}
                size={size}
                slug={slug}
                toggle={currentToggle}
              />
            </div>
          );
        }
      }
      i++;
    }
    return divs;
  };

  if (process.env.REACT_APP_PRINT === "true") return TogglePanelPrint(toggleValues, data, slug, size);

  return (
    <>
      {size !== "micro" ? (
        <>
          <Header figureData={data} slug={slug} currentToggle={currentToggle} />
          <TogglePane
            figureData={data}
            toggleValues={toggleValues}
            size={size}
            toggleDataSet={toggleDataSet}
            toggle={currentToggle}
          />
        </>
      ) : (
        <></>
      )}
      <div className="panel-layout">
        <div className="panel-child">
          {initPanel && initPanel.values ? (
            panelLayout(initialPanel.values).map((x) => x)
          ) : (
            <></>
          )}
        </div>
      </div>
      <PanelMethods methods={data.methods} />
      <Summary figureData={{ ...data, panel: null }} size={size} />
    </>
  );
};

export default TogglePanel;

const TogglePanelPrint = (toggleValues, data, slug, size) => {
   const graphs = [];
   const toggleSelections = Array.from(new Set(data.figurePrint.flatMap((x) => x.toggle)));
   toggleSelections.forEach(item => {
    if (toggleValues.includes(item))
    {
      let panel = data.togglePanel.filter((x) => x.toggle === item)[0];
      graphs.push(panel);
    }
  });

   return (
    <>
      {size !== "micro" ? (
        <>
          <Header figureData={data} slug={slug} />
        </>
      ) : (
        <></>
      )}
      {graphs.map((item, index) => (
        <div key={index} className="figure-print">
          <div className="figure-print-title">
            {item.toggle}
          </div>
          <div className="panel-layout">
            <div className="panel-child">
              {item && item.values ? (
                panelPrintLayout(item.values, data, size, slug, item.toggle).map((x) => x)
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      ))}
      <PanelMethods methods={data.methods} />
      <Summary figureData={data} size={size} />
    </>
  );
};

const panelPrintLayout = (panels, data, size, slug, currentToggle) => {
  let i = 0;
  const divs = [];
  while (i < panels.length) {
    if (i % 2 === 0) {
      if (i + 1 < panels.length) {
        divs.push(
          <div className="subpanels" key={i}>
            <PanelInstance
              panel={{
                ...data,
                panel: { ...panels[i], panelCount: panels.length },
              }}
              size={size}
              slug={slug}
              toggle={currentToggle}
            />
            <PanelInstance
              panel={{
                ...data,
                panel: { ...panels[i + 1], panelCount: panels.length },
              }}
              size={size}
              slug={slug}
              toggle={currentToggle}
            />
          </div>
        );
      } else {
        divs.push(
          <div className="subpanels" key={i}>
            <PanelInstance
              panel={{
                ...data,
                panel: { ...panels[i], panelCount: panels.length },
              }}
              size={size}
              slug={slug}
              toggle={currentToggle}
            />
          </div>
        );
      }
    }
    i++;
  }
  return divs;
};

